import AdminPublishBar from "./AdminPublishBar";

export default function AboutEditor({ content, storyDraft, saving, dirty, onChange, onDiscard, onStoryChange, onStatChange, onSubmit }) {
  return (
    <form className="admin-editor" onSubmit={onSubmit}>
      <div className="admin-editor-heading">
        <div>
          <p className="admin-kicker">Page content</p>
          <h2>About page</h2>
          <p>Changes remain private until you publish them.</p>
        </div>
        <a href="/about" target="_blank" rel="noopener noreferrer">View page</a>
      </div>
      <fieldset className="admin-form-section">
        <legend>Introduction</legend>
        <label>Kicker<input value={content.kicker} onChange={(event) => onChange("kicker", event.target.value)} required /></label>
        <label>Page title<input value={content.title} onChange={(event) => onChange("title", event.target.value)} required /></label>
        <label>Introduction<textarea rows="7" value={content.intro} onChange={(event) => onChange("intro", event.target.value)} required /></label>
      </fieldset>
      <fieldset className="admin-form-section">
        <legend>Highlights</legend>
        <div className="admin-stat-grid">
          {content.stats.map((stat, index) => (
            <fieldset key={index}>
              <legend>Highlight {index + 1}</legend>
              <label>Value<input value={stat.value} onChange={(event) => onStatChange(index, "value", event.target.value)} required /></label>
              <label>Label<input value={stat.label} onChange={(event) => onStatChange(index, "label", event.target.value)} required /></label>
            </fieldset>
          ))}
        </div>
      </fieldset>
      <fieldset className="admin-form-section">
        <legend>Story and image</legend>
        <label>Story heading<input value={content.storyTitle} onChange={(event) => onChange("storyTitle", event.target.value)} required /></label>
        <label>Story paragraphs <small>Separate paragraphs with a blank line.</small><textarea rows="14" value={storyDraft} onChange={(event) => onStoryChange(event.target.value)} required /></label>
        <label>Image URL<input type="url" value={content.imageUrl} onChange={(event) => onChange("imageUrl", event.target.value)} required /></label>
        <label>Image description<input value={content.imageAlt} onChange={(event) => onChange("imageAlt", event.target.value)} required /></label>
      </fieldset>
      <AdminPublishBar dirty={dirty} saving={saving} label="Publish About page" onDiscard={onDiscard} />
    </form>
  );
}
